/**
 * Awaitable logout: keep CSRF until the logout request is built and the server
 * confirms revocation. Do not clear CSRF in a finally-before-success path.
 */
export async function performLogout({ logoutRequest, clearSession, clearCsrf }) {
  await logoutRequest();
  clearCsrf();
  clearSession();
}
